import { Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalCloseButton, useBreakpointValue } from '@chakra-ui/react';

function ChatModal({ isOpen, onClose, children }) {
  const isFullScreen = useBreakpointValue({ base: true, md: false });

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="full" isCentered={true}>
      <ModalOverlay />
      <ModalContent borderRadius={0} borderTopRadius={8} borderBottomRadius={8}>
        <ModalHeader borderBottomWidth={1}>Chat</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          {children}
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}

export default ChatModal;